/**
 * chatbot.ts — Assistente global contextual (fase Chatbot).
 */

import type { components } from './generated/api'
import { api } from './http'

export type RespostaChatbot = components['schemas']['RespostaChatbot']
export type SugestoesChatbot = components['schemas']['SugestoesChatbot']
export type HistoricoChatbot = components['schemas']['HistoricoChatbot']
export type MensagemChatbot = components['schemas']['MensagemChatbot']

export function perguntarChatbot(
  mensagem: string,
  contexto: string,
  dadosContexto: Record<string, string> = {},
) {
  return api<RespostaChatbot>('/api/v1/chatbot/perguntar', {
    method: 'POST',
    body: { mensagem, contexto, dados_contexto: dadosContexto },
  })
}

export function sugestoesChatbot(contexto: string) {
  return api<SugestoesChatbot>(
    `/api/v1/chatbot/sugestoes?contexto=${encodeURIComponent(contexto)}`,
  )
}

export function historicoChatbot(contexto: string) {
  return api<HistoricoChatbot>(
    `/api/v1/chatbot/historico?contexto=${encodeURIComponent(contexto)}`,
  )
}

export function limparHistoricoChatbot(contexto: string) {
  return api<{ limpo: boolean }>(
    `/api/v1/chatbot/historico?contexto=${encodeURIComponent(contexto)}`,
    { method: 'DELETE' },
  )
}
